<div id="timeSlotDialogCard" class="control-card-white">

    <div class="control-card-header">
        <ng-container i18n="@@time_slot_dialog_add_time_slot">Aggiungi fascia oraria</ng-container>
        <fa-icon icon="times" class="float-right margin-right-20 icon-clickable"
            (click)="closeTimeSlotDialog()"></fa-icon>
    </div>

    <div class="control-card-content">

        <p class="text-small text-dark" i18n="@@time_slot_dialog_select_starting_time">
            Seleziona l'orario di inizio:
        </p>

        <div class="time-container">
            <select (change)="selectFromHourChanged($event)" id="dialog-time-slot-from-hour">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
            </select>
            <select *ngIf="!fiveMinPrecision && !tenMinPrecision" (change)="selectFromMinutesChanged($event)"
                id="dialog-time-slot-from-minute">
                <option value="00">00</option>
                <option value="30">30</option>
            </select>
            <select *ngIf="tenMinPrecision" (change)="selectFromMinutesChanged($event)"
                id="dialog-time-slot-from-minute">
                <option value="00">00</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
            </select>
            <select *ngIf="fiveMinPrecision" (change)="selectFromMinutesChanged($event)"
                id="dialog-time-slot-from-minute">
                <option value="00">00</option>
                <option value="05">05</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
                <option value="35">35</option>
                <option value="40">40</option>
                <option value="45">45</option>
                <option value="50">50</option>
                <option value="55">55</option>
            </select>
        </div>

        <p class="text-small text-dark margin-top-10" i18n="@@time_slot_dialog_select_ending_time">
            Seleziona l'orario di fine:
        </p>

        <div class="time-container">
            <select (change)="selectToHourChanged($event)" id="dialog-time-slot-to-hour">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
            </select>
            <select *ngIf="!fiveMinPrecision && !tenMinPrecision" (change)="selectToMinutesChanged($event)"
                id="dialog-time-slot-to-minute">
                <option value="00">00</option>
                <option value="30" *ngIf="!toMidnight">30</option>
            </select>
            <select *ngIf="tenMinPrecision" (change)="selectToMinutesChanged($event)" id="dialog-time-slot-to-minute">
                <option value="00">00</option>
                <option value="10" *ngIf="!toMidnight">10</option>
                <option value="20" *ngIf="!toMidnight">20</option>
                <option value="30" *ngIf="!toMidnight">30</option>
                <option value="40" *ngIf="!toMidnight">40</option>
                <option value="50" *ngIf="!toMidnight">50</option>
            </select>
            <select *ngIf="fiveMinPrecision" (change)="selectToMinutesChanged($event)" id="dialog-time-slot-to-minute">
                <option value="00">00</option>
                <option value="05" *ngIf="!toMidnight">05</option>
                <option value="10" *ngIf="!toMidnight">10</option>
                <option value="15" *ngIf="!toMidnight">15</option>
                <option value="20" *ngIf="!toMidnight">20</option>
                <option value="25" *ngIf="!toMidnight">25</option>
                <option value="30" *ngIf="!toMidnight">30</option>
                <option value="35" *ngIf="!toMidnight">35</option>
                <option value="40" *ngIf="!toMidnight">40</option>
                <option value="45" *ngIf="!toMidnight">45</option>
                <option value="50" *ngIf="!toMidnight">50</option>
                <option value="55" *ngIf="!toMidnight">55</option>
            </select>
        </div>

    </div>

    <div class="control-card-buttons">

        <a (click)="addTimeSlot()" class="button">
            <ng-container i18n="@@time_slot_dialog_save">Salva</ng-container> <span><fa-icon
                    icon="plus-circle"></fa-icon></span>
        </a>
        <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="error"
            i18n="@@time_slot_dialog_error_invalid_times">
            Gli orari inseriti non sono validi
        </p>

    </div>

</div>